import { removeUnlockSizeRatioMediaElementAction as removeUnlockSizeRatioMediaElementOperation } from 'editor/src/store/editor/slice';

export default removeUnlockSizeRatioMediaElementOperation;
